import PurchaseOrderItems from "./purchase-order-items";
import TotalPrice from "./total-price";
import Decimal from "decimal.js";

/**
 * 発注情報
 */
export default class PurchaseOrder {
  public constructor(
    public id: number = 0,
    public projectId: number = 0,
    public projectName: string = "",
    public projectOwnerName: string = "",
    public title: string = "",
    public mention: string = "",
    public status: string = "created",
    public statusName: string = "",
    public estimateId: number = 0,
    public estimateTaxRate: number = 0,
    public vendorId: number = 0,
    public vendorName: string = "",
    public taxRate: number = 0,
    public items: PurchaseOrderItems = new PurchaseOrderItems(),
    public printsExcludeTax: boolean = false,
    public issuedAt: string = "",
    public dateOfIssue: string = "",
    public purchaseNumber: string = "",
    public estimateNumber: string = ""
  ) {}

  public get profit(): number {
    return new Decimal(this.estimateTotal).minus(this.total).toNumber();
  }

  /**
   * 利益率 [%]
   */
  public get profitRate(): number {
    if (this.estimateTotal === 0) {
      return 0;
    }
    return new Decimal(this.profit)
      .div(this.estimateTotal)
      .mul(100)
      .toNumber();
  }

  public get estimateSubtotal(): number {
    return this.items.totalPrice.toNumber();
  }

  public get estimateTax(): number {
    return new TotalPrice(this.items.totalPrice)
      .tax(new Decimal(this.estimateTaxRate))
      .toNumber();
  }

  public get estimateTotal(): number {
    return new TotalPrice(this.items.totalPrice)
      .withTax(new Decimal(this.estimateTaxRate))
      .toNumber();
  }

  public get subtotal(): TotalPrice {
    return new TotalPrice(this.items.totalLoss);
  }

  public get tax(): Decimal {
    return this.subtotal.tax(this.taxRate);
  }

  public get total() {
    return this.subtotal.withTax(this.taxRate);
  }

  public toJSON(): any {
    return {
      id: this.id,
      projectId: this.projectId,
      projectName: this.projectName,
      staffName: this.projectOwnerName,
      title: this.title,
      mention: this.mention,
      status: this.status,
      statusName: this.statusName,
      estimateId: this.estimateId,
      estimateTotal: this.estimateTotal,
      estimateSubtotal: this.estimateSubtotal,
      estimateTax: this.estimateTax,
      estimateTaxRate: this.estimateTaxRate,
      vendorId: this.vendorId,
      vendorName: this.vendorName,
      loss: this.subtotal.toNumber(),
      lossTotal: this.total.toNumber(),
      tax: this.tax.toNumber(),
      taxRate: this.taxRate,
      items: this.items.toJSON(),
      printsExcludeTax: this.printsExcludeTax,
      issuedAt: this.issuedAt,
      profit: this.profit,
      profitRate: this.profitRate,
      dateOfIssue: this.dateOfIssue,
      purchaseNumber: this.purchaseNumber,
      estimateNumber: this.estimateNumber
    };
  }
}
